const SRAVNI_UTM_SOURCE = 'cpa'

const checkIsSravniUtmSource = (str: string | undefined) =>
  str === SRAVNI_UTM_SOURCE

export default checkIsSravniUtmSource
